import loopCreate from './loopCreate.js';
import loopFix from './loopFix.js';
import loopDestroy from './loopDestroy.js';

export defa mx-1  ult {
  loopCreate,
  loopFix,
  loopDestroy,
};
